import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import AdminDashboard from './pages/AdminDashboard';
import TeamLogin from './pages/TeamLogin';
import TeamAnswers from './pages/TeamAnswers';
import AdminCodeGenerator from './pages/AdminCodeGenerator';
import AdminController from './pages/AdminController';
import AdminScoring from './pages/AdminScoring';
import Header from './components/Header';
import AdminLogin from './pages/AdminLogin';
import ProtectedAdminRoute from './components/ProtectedAdminRoute';
import AdminTeams from './pages/AdminTeams';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50 pt-20">
        <Header />
        <Routes>
          {/* Default route: Team login/registration */}
          <Route path="/" element={<TeamLogin />} />

          {/* After successful registration, go to answers */}
          <Route path="/team/answers" element={<TeamAnswers />} />


          {/* Optional: Catch-all redirect to home */}
          <Route path="*" element={<TeamLogin />} />



          <Route path="/admin/login" element={<AdminLogin />} />
<Route path="/admin/dashboard" element={
  <ProtectedAdminRoute>
    <AdminDashboard />
  </ProtectedAdminRoute>
} />
<Route path="/admin/generate" element={
  <ProtectedAdminRoute>
    <AdminCodeGenerator />
  </ProtectedAdminRoute>
} />
<Route path="/admin/controller" element={
  <ProtectedAdminRoute>
    <AdminController />
  </ProtectedAdminRoute>
} />
<Route path="/admin/scoring" element={
  <ProtectedAdminRoute>
    <AdminScoring />
  </ProtectedAdminRoute>
} />

<Route path="/admin/teams" element={<ProtectedAdminRoute><AdminTeams /></ProtectedAdminRoute>} />
        </Routes>

        {/* Small admin link in footer - visible on team pages */}
        <footer className="fixed bottom-0 left-0 right-0 bg-gray-800 text-white text-center py-2">

        </footer>
      </div>
    </Router>
  );
}

export default App;